// removed by extract-text-webpack-plugin
module.exports = {"root":"Package__root___2aykD","large":"Package__large___14qZp"};